import { useCountUp } from './StoryCounter';

export function ProgressRing({
  percentage,
  size = 120,
  strokeWidth = 10,
  active,
}: Readonly<{
  percentage: number;
  size?: number;
  strokeWidth?: number;
  active: boolean;
}>) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const animatedPct = useCountUp(Math.min(percentage, 100), active, 2000);
  const offset = circumference - (animatedPct / 100) * circumference;

  return (
    <svg width={size} height={size} className="transform -rotate-90 text-primary drop-shadow-sm">
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        fill="none"
        className="text-muted/30"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        className="text-primary transition-[stroke-dashoffset] duration-[2s] ease-out"
      />
    </svg>
  );
}
